import styled from "styled-components"

import { minWidth } from "utils"

import ContentfulSignupForm from "components/page-components/sign-up-form"

export const Container = styled(ContentfulSignupForm)`
  width: 100%;
  padding: 0;
  background-color: #fff;

  form {
    max-width: 100%;
    text-align: left !important;

    // heading
    h2 {
      width: 100%;
      margin: 0;
      padding-top: 0;
      padding-bottom: 0.6rem;
      border: 0;
      font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 2.8rem;
      line-height: 1.56;
      text-align: left;

      ${minWidth.desktop`
        width: 100%;
        padding-top: 0;
        font-size: 3.2rem;
      `}
    }

    // body text
    div > p {
      margin-top: 0;
      padding-top: 0.5rem;
      font-size: 1.6rem;
      line-height: 1.56;
    }

    input[type="email"] {
      border: 0.1rem solid rgba(34, 34, 34, 0.2);
      margin-top: 0;
      margin-bottom: 1.6rem;

      ${minWidth.mobile`
        width: 60%;
        margin: 0;
      `}
    }

    input[type="submit"] {
      width: 100%;
      height: 100%;
      padding: 1.6rem 0;
      border: 0;
      background-color: ${({ theme }) => theme.colors.primaryBlue};
      font-size: 1.6rem;

      ${minWidth.mobile`
        width: 35%;
      `}
    }

    .signup-success {
      height: unset;
      margin: 0;
    }

    // terms
    > :last-child {
      margin-top: 1.6rem;
      color: rgba(34, 34, 34, 0.6);

      ${minWidth.mobile`
        margin-top: 1.2rem;
      `}
    }
  }

  ${minWidth.tablet`
    max-width: 58rem;
  `}

  ${minWidth.desktop`
    max-width: 72.5rem;
  `}
`
